export const FirmModel = {
    applicant_name: '',
    cnic_no: '',
    business_name: '',
    ntn_number: '',
    gst_number: '',
    business_address: '',
    city_id: '',
    email_address: '',
    mobile_no: null,
    alternate_no: null,
    phone_no: null,
    fax_no: null,
    branch_offices: null,
    branch_one_address: null,
    branch_two_address: null,
    branch_three_address: null,
    corporate_status: '',
    established_year: '',
    categories: [],
    cnic: [],
    ntn: [],
    other_documents: [],
    profile: []


}
export const BRANCH_OFFCIES_YES = 1;
export const BRANCH_OFFCIES_NO = 2;

export const BRANCH_OFFICES_NAMES = {
    1: 'Yes',
    2: 'No',
};

export const BRANCH_OFFICES_DROPDOWN_OPTIONS = [
    { value: BRANCH_OFFCIES_YES, label: BRANCH_OFFICES_NAMES[BRANCH_OFFCIES_YES] },
    { value: BRANCH_OFFCIES_NO, label: BRANCH_OFFICES_NAMES[BRANCH_OFFCIES_NO] },
];

export const CORPORATE_STATUS_SOLE_PROPERITER = 1;
export const CORPORATE_STATUS_PARTERNERSHIP = 2;
export const CORPORATE_STATUS_LIMITED = 3;

export const CORPORATE_STATUS_NAMES = {
    1: 'Sole Properiter',
    2: 'Parternership',
    3: 'Limited',
};

export const CORPORATE_STATUS_DROPDOWN_OPTIONS = [
    { value: CORPORATE_STATUS_SOLE_PROPERITER, label: CORPORATE_STATUS_NAMES[CORPORATE_STATUS_SOLE_PROPERITER] },
    { value: CORPORATE_STATUS_PARTERNERSHIP, label: CORPORATE_STATUS_NAMES[CORPORATE_STATUS_PARTERNERSHIP] },
    { value: CORPORATE_STATUS_LIMITED, label: CORPORATE_STATUS_NAMES[CORPORATE_STATUS_LIMITED] },

];